import { DialogTitle } from '@headlessui/react';
import { useTranslation } from 'react-i18next';

import Modal from '../../../widgets/Modal';
import Button from '../../../widgets/Button';
import { useMfaModalContext } from '../../../../shared/providers/MfaModalProvider';

import { MfaModalState } from '../../../../shared/constants/MFA';
import mfaVisual from '../../../../assets/icons/mfa/mfa-visuals.png';

function EnableTwoFAModal({ enabled }: { enabled: boolean }) {
  const { t } = useTranslation();
  const { setActiveModal } = useMfaModalContext();

  const handleClickModal = () => setActiveModal(MfaModalState.ScanQrCode);
  return (
    <Modal open={enabled} modalClassName="max-w-[450px]">
      <div className="mt-[51px] grid justify-center px-6 text-center">
        <img
          src={mfaVisual}
          className="m-auto mb-[26.66px] w-[214px]"
          alt="Mfa visuals"
        />
        <DialogTitle
          as="h4"
          className="text-black-900 mb-2 text-lg font-semibold"
        >
          {t('ENABLE_TWO_FACTOR')}
        </DialogTitle>
        <span className="text-black-600 mb-[44px] text-sm">
          {t('ENABLE_TWO_FACTOR_SUBTITLE')}
        </span>
        <Button size="lg" onClick={handleClickModal}>
          {t('GET_STARTED')}
        </Button>
      </div>
    </Modal>
  );
}

export default EnableTwoFAModal;
